<script setup>
import { Head, useForm } from '@inertiajs/vue3';
import GuestLayout from '@/Layouts/GuestLayout.vue';
import Button from 'primevue/button';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Message from 'primevue/message';

const form = useForm({
  password: '',
});

const submit = () => {
  form.post(route('password.confirm'), {
    onFinish: () => form.reset(),
  });
};
</script>

<template>
  <GuestLayout>
    <Head title="Confirmer votre mot de passe"/>

    <div class="mt-6 text-sm text-gray-600">
      Vous accédez à une zone sécurisée de l'application.
      Veuillez confirmer votre mot de passe avant de continuer.
    </div>

    <form @submit.prevent="submit">
      <div class="mt-6 flex flex-col gap-2">
        <FloatLabel variant="on">
          <InputText
              id="password"
              type="password"
              fluid
              autofocus
              autocomplete="current-password"
              required
              v-model="form.password"
              :invalid="!!form.errors.password"
          />

          <label for="email">Mot de passe</label>
        </FloatLabel>

        <Message v-if="!!form.errors.password" severity="error">
          {{ form.errors.password }}
        </Message>
      </div>

      <div class="my-6 flex justify-end">
        <Button type="submit" :disabled="form.processing">
          Confirmer
        </Button>
      </div>
    </form>
  </GuestLayout>
</template>
